import { ModalCancelButton, ModalCloseButton } from '@dreryk/react-components';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

import { magistralDrugTemplatesTranslationKeys } from '../../../../../translations';
import { MagistralDrugTemplates } from '../MagistralDrugTemplates';
import { MagistralDrugInitialEditTemplate, MagistralDrugTemplateUse } from '../MagistralDrugTemplates.types';
import { MagistralDrugTemplatesSendTemplateButton } from '../MagistralDrugTemplatesSendTemplateButton';
import { MagistralDrugTemplatesUseTemplateModalConfirmButton } from '../MagistralDrugTemplatesUseTemplateModalConfirmButton';
import { MagistralDrugTemplateInsert } from '../readOnly/MagistralDrugReadOnly.types';

type MagistralDrugTemplatesModalProps = {
   readonly onClose: VoidFunction;
   readonly onInsert: MagistralDrugTemplateInsert;
   readonly onUse: MagistralDrugTemplateUse;
   readonly shouldConfirmUse: boolean;
   readonly initialEditTemplate: MagistralDrugInitialEditTemplate;
};

export const MagistralDrugTemplatesModal = (props: MagistralDrugTemplatesModalProps): JSX.Element => {
   return (
      <FormsTemplates.Modal
         testId={'magistralDrugTemplates'}
         title={magistralDrugTemplatesTranslationKeys.magistralDrugTemplates}
      >
         <MagistralDrugTemplates
            initialEditTemplate={props.initialEditTemplate}
            onInsert={props.onInsert}
            editSlot={({ handleSubmit, ready, onTemplateSaveSuccess, formState }) => (
               <>
                  <MagistralDrugTemplatesSendTemplateButton
                     handleSubmit={handleSubmit}
                     onSuccess={onTemplateSaveSuccess}
                     disabled={ready}
                  />
                  <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                  <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
               </>
            )}
            readOnlySlot={
               <MagistralDrugTemplatesUseTemplateModalConfirmButton
                  shouldConfirm={props.shouldConfirmUse}
                  onClick={(template) => {
                     props.onUse(template);
                     props.onClose();
                  }}
               />
            }
         >
            <FormsTemplates.ExitModalButtons onCancel={props.onClose} />
         </MagistralDrugTemplates>
      </FormsTemplates.Modal>
   );
};
